process.env['MAILGUN_API_KEY'] = "3e453cf6a05f28861f21ee65ed9e8d0c-47317c98-a8722910";
process.env['MAILGUN_DOMAIN'] = "mailgun.ostll.ca";
process.env['MAILGUN_API_URL'] = "https://api.mailgun.net/v2";
